import {isDevMode} from '@angular/core';
import {provideEffects} from '@ngrx/effects';
import {provideRouterStore, routerReducer} from '@ngrx/router-store';
import {provideState, provideStore} from '@ngrx/store';
import {provideStoreDevtools} from '@ngrx/store-devtools';
import {AuthenticationEffects} from '@state/authentication/authentication.effects';
import {authenticationFeature} from '@state/authentication/authentication.feature';
import {BranchEffects} from '@state/branch/branch.effects';
import {branchFeature} from '@state/branch/branch.feature';
import {CommonEffects, commonFeature} from '@state/common';
import {FavoritesEffects, favoritesFeature} from '@state/favorites';
import {HistoryEffects, historyFeature} from '@state/history';
import {RouterEffects} from '@state/router/router.effects';
import {SearchEffects, searchFeature} from '@state/search';
import {SettingsEffects, settingsFeature} from '@state/settings';
import {SubjectEffects, subjectFeature} from '@state/subject';

export const NGRX_PROVIDERS = [
  provideStore({
    router: routerReducer,
  }),
  provideRouterStore(),

  // Features
  provideState(authenticationFeature),
  provideState(settingsFeature),
  provideState(subjectFeature),
  provideState(commonFeature),
  provideState(searchFeature),
  provideState(historyFeature),
  provideState(favoritesFeature),
  provideState(branchFeature),

  // Effects
  provideEffects(
    AuthenticationEffects,
    RouterEffects,
    SettingsEffects,
    CommonEffects,
    SubjectEffects,
    SearchEffects,
    HistoryEffects,
    FavoritesEffects,
    BranchEffects
  ),

  // Devtools
  ...(isDevMode()
    ? [
        provideStoreDevtools({
          maxAge: 25,
          logOnly: false,
          autoPause: true,
          trace: false,
          traceLimit: 75,
          connectInZone: true,
        }),
      ]
    : []),
];
